// DEPENDENCIES
import React, { useState } from 'react';
// COMPONENTS
import { Link } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';

// ICONS
import { BsFillLightningFill, BsLightningFill, BsTagFill } from 'react-icons/bs';
import { FaClipboardList, FaBoxOpen } from 'react-icons/fa';
import { IoPersonAddSharp } from 'react-icons/io5';
import { HiMenuAlt2 } from 'react-icons/hi';

// CUSTOM COMPONENTS
import FormBlock from '../components/FormBlock';
import InputBlock from '../components/InputBlock';
import Section from '../components/Section';
import ContentBlock from '../components/ContentBlock';
import CustomBlock from '../components/CustomBlock';
import LogoBlock from '../components/LogoBlock';
import Button from '../components/Button';
import LoadingScreen from '../components/LoadingScreen';
import UserLoginValidator from '../helpers/validators/User/UserLoginValidator';

// ASSETS
import { Authenticate } from '../services/user.service';
import { IsUserLoggedIn, SaveItemInLocalStorage } from '../helpers/helper';
import { useFormik } from 'formik';

const LoginPage = (props) => {
    const [loading, setLoading] = useState(false);

    const AuthenticateUser = (values, setSubmitting) => {
        setLoading(true);
        Authenticate(values).then(res => {
            SaveItemInLocalStorage("user", res);
            setSubmitting(false);
            props.history.push(IsUserLoggedIn() === "Admin" ? "/dashboard" : "/dashboard");
        }).catch(ex => {
            setSubmitting(false);
            setLoading(false);
            console.log(ex);
        })
    }


    const formik = useFormik({
        initialValues: { username: "", password: "" },
        validationSchema: UserLoginValidator,
        onSubmit: (values, { setSubmitting }) => {
            AuthenticateUser(values, setSubmitting);
        }
    });

    return (
        <>
            {
                loading ?
                    <LoadingScreen /> :
                    <CustomBlock
                        className="white--bg"
                        style={{ height: '100vh' }}
                    >
                        <LogoBlock />
                        <Section
                            rowClassName=""
                        >
                            <ContentBlock>
                                <FormBlock className="login-form-block" onSubmit={formik.handleSubmit}>
                                    <CustomBlock className="login-form-items">
                                        <InputBlock
                                            id="username"
                                            inputLabel="Username"
                                            {...formik.getFieldProps("username")}
                                            inputState={formik.touched.username && formik.errors.username ? "error" : formik.touched.username && formik.errors.username == null ? "success" : ""}
                                            errorMessage={formik.errors.username}
                                            autoCapitalize={false}
                                            tabIndex="0"
                                        />
                                        <InputBlock
                                            id="password"
                                            inputLabel="Password"
                                            type="password"
                                            {...formik.getFieldProps("password")}
                                            inputState={formik.touched.password && formik.errors.password ? "error" : formik.touched.password && formik.errors.password == null ? "success" : ""}
                                            errorMessage={formik.errors.password}
                                            tabIndex="1"
                                        />
                                        <div className="login-actions">
                                            {/* <Link
                                                id="forgot-password"
                                                to="/forgot-password"
                                                className="forgot-password"
                                            >
                                                Forgot Password?
                                                </Link> */}
                                            <Button
                                                text="Login"
                                                type="submit"
                                                className="primary--bg"
                                                disabled={formik.isSubmitting}
                                            />
                                        </div>
                                    </CustomBlock>
                                </FormBlock>
                            </ContentBlock>
                        </Section>
                    </CustomBlock>
            }
        </>
    );
}

export default LoginPage;